export default function GrainOverlay() {
  return <div aria-hidden="true" className="grain-overlay" data-testid="grain-overlay" />;
}
